// pass in an object of key value pairs and it will return a query string for use
// with 'content-type': 'application/x-www-form-urlencoded' requests
// this will probably only work with a flat object
export const buildBody = (obj) => {
    const params = new URLSearchParams();
    for (const key in obj) {
        params.append(key, obj[key]);
    }
    return params.toString();
}